import React from "react";
import Link from "next/link";
import LayoutBasic from "../layouts/layoutBasic";
import { CONTACT_US, TOKEN, GET_USER_URL } from "../vars";
import { setLocalKeyValue, getLocalKeyValue } from "../storage";
import { GET, UPOST } from "../helpers";
import { withRouter } from "next/router";
import ReCAPTCHA from "react-google-recaptcha";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faFacebookF,
  faTwitter,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

class ContactUs extends React.Component {
  constructor() {
    super();
    this.state = {
      name: "",
      email: "",
      message: "",
      submit_success: false,
      submit_failed: false,
      submitting: false,
    };
  }
  static async getInitialProps(props) {
    let token = (await process.browser)
      ? getLocalKeyValue(TOKEN)
      : props.query.sec_token;

    let infoRequest,
      infoResponse = {};
    if (token) {
      try {
        infoRequest = await GET(GET_USER_URL, token);
        infoResponse = await infoRequest.data;
      } catch (e) { }
    }

    return {
      token: token,
      user: infoResponse.user,
      cart: infoResponse.cart,
    };
  }
  inputChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({
      [name]: value,
    });
    this.setState({
      submit_failed: false,
      submit_success: false,
      submitting: false,
    });
  };
  contactus = (e) => {
    this.setState({ submitting: true });
    e.preventDefault();

    let data = {
      name: this.state.name,
      message: this.state.message,
      email: this.state.email,
      reCaptcha: this.state.reCaptcha_value,
    };

    UPOST(CONTACT_US, data)
      .then((response) => {
        if (response.data.success) {
          this.setState({ submit_success: true, submitting: false });
        } else {
          this.setState({ submit_failed: true, submitting: false });
        }
      })
      .catch((error) => {
        this.setState({ submit_failed: true, submitting: false });
      });
  };

  reCaptchaChange = (value) => {
    this.setState({ reCaptcha_value: value });
  };
  render() {
    let submitButton = (
      <button
        type="submit"
        className="btn btn-primary btn-block"
        disabled="disabled"
      >
        Send Message{" "}
      </button>
    );

    if (
      this.state.name &&
      this.state.email &&
      this.state.message &&
      this.state.reCaptcha_value
    ) {
      submitButton = (
        <button type="submit" className="btn btn-primary btn-block">
          Send Message{" "}
        </button>
      );
    }

    if (this.state.submit_failed) {
      submitButton = (
        <button type="submit" className="btn btn-danger btn-block">
          Failed
        </button>
      );
    }
    if (this.state.submit_success) {
      submitButton = (
        <button type="submit" className="btn btn-success btn-block">
          Message sent successfully
        </button>
      );
    }
    if (this.state.submitting) {
      submitButton = (
        <button type="submit" className="btn btn-primary btn-block" disabled>
          Sending...
        </button>
      );
    }

    let reCaptcha = (
      <ReCAPTCHA
        ref="reCaptcha"
        sitekey="6LcBCLAUAAAAALrXPtrZEGCSNk7LcUS5BwhlBaOc"
        onChange={this.reCaptchaChange}
      />
    );

    let form = (
      <>
        <form onSubmit="#">
          <div className="form-group">
            <label htmlFor="name" className="text-muted ">
              Name
            </label>
            <input
              id="name"
              name="name"
              type="text"
              className="form-control"
              value={this.state.name}
              onChange={this.inputChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email" className="text-muted ">
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              className="form-control"
              value={this.state.email}
              onChange={this.inputChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message" className="text-muted ">
              Message
            </label>
            <textarea
              id="message"
              name="message"
              type="password"
              className="form-control"
              value={this.state.message}
              onChange={this.inputChange}
              required
            ></textarea>
          </div>
          <div className="form-group">{reCaptcha}</div>
          {submitButton}
        </form>
      </>
    );

    if (this.state.submit_success) {
      form = (
        <div className="text-success">
          Thanks for contacting us we will be in touch with you shortly
        </div>
      );
    }

    return (
      <LayoutBasic title="Contact Us" {...this.props}>
        <div className="container my-5">
          <h1>Contact</h1>
          <div className="row">
            <div className="col-sm-6">
              <div className="border rounded p-2 p-md-5">
                Please e-mail any queries/issues to&nbsp;
                <a href="mailto:support@picxy.com">support@picxy.com</a>&nbsp;
                or contact us at : +91 8885558235
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="contactus mt-4 mt-md-0 pl-md-5">
                <p className="lead">Our Social Media Platforms</p>
                <div className="row">
                  <div className="col-md-3 col-6 mb-3">
                    <Link href="https://www.facebook.com/picxydotcom/">
                      <a target="_blank" className="text-center">
                        <FontAwesomeIcon icon={faFacebookF} /> Facebook
                      </a>
                    </Link>
                  </div>
                  <div className="col-md-3 col-6 mb-3">
                    <Link href="https://www.instagram.com/picxydotcom/">
                      <a target="_blank" className="text-center">
                        <FontAwesomeIcon icon={faInstagram} /> Instagram
                      </a>
                    </Link>
                  </div>
                  <div className="col-md-3 col-6 mb-3">
                    <Link href="https://www.linkedin.com/company/11191201/">
                      <a target="_blank" className="text-center">
                        <FontAwesomeIcon icon={faLinkedin} /> Linkedin
                      </a>
                    </Link>
                  </div>
                  <div className="col-md-3 col-6 mb-3">
                    <Link href="https://twitter.com/picxydotcom">
                      <a target="_blank" className="text-center">
                        <FontAwesomeIcon icon={faTwitter} /> Twitter
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutBasic>
    );
  }
}

export default withRouter(ContactUs);
